import axios from 'axios'
import jwt from 'jsonwebtoken';
import crypto from 'crypto';
import { X } from 'react-feather'
import { toastify, sendMessageToParent, REACT_APP_LOGIN_PAGE, REACT_APP_SIGNUP_PAGE, clearLeadStatusArrayFromLocal } from '@utils'
import jwtDefaultConfig from './jwtDefaultConfig'

import dotenv from 'dotenv';
dotenv.config();

const {
  REACT_APP_DATA_ENCRYPTION_TOKEN = 'Se!cure$me',
  REACT_APP_API_CHECKSUM_SECRET_KEY
} = process.env;

export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // ** For Refreshing Token
  subscribers = []

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    axios.defaults.withCredentials = true;

    // ** Request Interceptor
    axios.interceptors.request.use(
      config => {
        if (!config.url.includes('/user/track')) {
          window.localStorage.setItem('lastApiCallTime', Date.now());
        }
        config.headers['x-timestamp'] = parseInt(Date.now() / 1000);
        config.headers['x-tenant'] = localStorage.getItem('tenant') || '';
        config.headers['x-platform'] = localStorage.getItem('platform') || 'WEB';
        config.headers['x-os'] = localStorage.getItem('os') || '';
        config.headers['x-appversion'] = localStorage.getItem('appVersion') || '';
        config.headers['x-checksum'] = this.generateChecksum(`${config.headers['x-timestamp']}${config.headers['x-tenant']}${config.headers['x-platform']}${REACT_APP_API_CHECKSUM_SECRET_KEY}`, REACT_APP_API_CHECKSUM_SECRET_KEY);
        return config
      },
      error => Promise.reject(error)
    )

    // ** Add request/response interceptor
    axios.interceptors.response.use(
      response => response,
      error => {
        // ** const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        // ** if (status === 401) {
        if (response && response.status === 401 && !location.pathname.includes('login') && !originalRequest.url.includes('refreshToken')) {
          // ** Remove user, accessToken & refreshToken from localStorage
          localStorage.removeItem('userData')
          localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
          localStorage.removeItem(this.jwtConfig.storageRefreshTokenKeyName)
          localStorage.removeItem('userToken')
          localStorage.removeItem('lastApiCallTime')
          localStorage.removeItem('lastTrackTime')
          clearLeadStatusArrayFromLocal();
          sendMessageToParent({ type : "USER_LOGOUT", data : {} })
          let errorMsg = response.data && response.data.result && response.data.result.msg || "session terminated, please login again";
          if (![REACT_APP_LOGIN_PAGE, REACT_APP_SIGNUP_PAGE].includes(window.location.pathname)) {
            if (!localStorage.getItem('redirect_error_msg')) {
              localStorage.setItem('redirect_error_msg', errorMsg);
            }
            window.location.href = '/';
          }
          // Important: We deleted the `retryOriginalRequest` block!
          // Since the user is logged out, we just reject the API call immediately.
        }
        return Promise.reject(error)
      }
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers.forEach(callback => callback(accessToken))
    this.subscribers = []
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return axios.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return axios.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return axios.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken()
    })
  }

  generateChecksum(key, secret) {
    const hash = crypto.createHash('md5');
    hash.update(key + secret);
    return hash.digest('hex');
  }
}
